<div class="dialog-container">

    <div class="dialog-header">
        <div class="icon-container">
            <mat-icon class="confirm-icon">assignment_turned_in</mat-icon>
        </div>
        <h2 mat-dialog-title class="dialog-title">Confirmação de Boleta</h2>
    </div>

    <div mat-dialog-content class="dialog-content">

        <div class="section">
            <div class="section-title">
                <mat-icon>person</mat-icon>
                Dados do Cliente
            </div>
            <div class="data-grid">
                <span class="label">Conta</span>
                <span class="value">{{ data.cliente.numero_xp }}</span>
                <span class="label">Cliente</span>
                <span class="value">{{ data.cliente.nome }}</span>
            </div>
        </div>

        <mat-divider></mat-divider>

        <div class="section">
            <div class="section-title">
                <mat-icon>swap_horiz</mat-icon>
                Dados da Movimentação
            </div>
            <div class="estrategia-badge">{{ data.estrategia }}</div>
            <div class="data-grid">
                <span class="label">Data</span>
                <span class="value">{{ data.data_operacao | date:'dd/MM/yyyy' }}</span>
                <span class="label">Observação</span>
                <span class="value">{{ data.observacao || '—' }}</span>
            </div>
            <div class="valor-container">
                <span class="valor-label">Valor Movimentado</span>
                <span class="valor-highlight">R$ {{ data.valor_total | number:'1.2-2' }}</span>
            </div>
        </div>

    </div>

    <div mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="onNoClick()" class="cancel-button" tabindex="2">Cancelar</button>
        <button mat-raised-button (click)="salvar()" class="info-button" tabindex="0">Confirmar</button>
    </div>

</div>
